import {fabric} from 'fabric';
import {AbstractShapeFactory} from './AbstractShapeFactory';
import {WBUtils} from '../util/WBUtils';

export class UMLObjectFactory extends AbstractShapeFactory {

  constructor() {
    super();
    this.awType = 'uml';
    this.parentButton = WBUtils.buttonAdvanced;
  }

  /**
     * Creates and returns a fabric path object at position (anchorX/anchorY) and sets
     * the attriubtes color, fill and stroke
     */
  public create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any {
    const umlPath = 'M 0 2 L 0 0 L 10 0 L 10 12 L 0 12 L 0 2 L 10 2 Z';

    this.shapeObject = new fabric.Path(umlPath);
    this.shapeObject.set({
      left: anchorX,
      top: anchorY,
      fill: fill,
      stroke: color,
      strokeWidth: stroke / 30
    });
    this.shapeObject.scaleToWidth(5);
    return this.shapeObject;
  }

  /**
     * modifies the path object expanding it to position (eventX/eventY), also checks
     * the direction of movement with position (anchorX, anchorY).
     */
  public modify(anchorX: number, anchorY: number, eventX: number, eventY: number) {
    if (anchorX > eventX) {
      this.shapeObject.set({
        left: Math.abs(eventX)
      });
    }
    if (anchorY > eventY) {
      this.shapeObject.set({
        top: Math.abs(eventY)
      });
    }

    this.shapeObject.scaleToWidth(Math.abs(anchorX - eventX));
    this.shapeObject.setCoords();
  }

  /**
     * Executes the copy method of the AbstractShapeFactory
     */
  public copyAndDrop(id: number, awtype: string, callback: (clone) => void) {
    this.copy(id, awtype, callback);
  }
}
